export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7624.e5d541a7.jpg";